import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {OtrasGestionesComponent} from './otras-gestiones/otras-gestiones.component';
import { FormConsultasComponent } from './form-consultas/form-consultas.component';
import { FormConsultasFacturacionComponent } from './form-consultas-facturacion/form-consultas-facturacion.component';
import { RouterModule } from '@angular/router';
import { LayoutModule } from "app/layout/layout.module"; 
import { MatExpansionModule } from '@angular/material/expansion';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatOptionModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';



const routes = [
  {
    path: 'proveedores/otras-gestiones',
    component: OtrasGestionesComponent
  },
  {
    path: 'proveedores/otras-gestiones/consultas-proveedor',
    component: FormConsultasComponent
  },{
    path: 'proveedores/otras-gestiones/consulta-facturacion-proveedor',
    component: FormConsultasFacturacionComponent
  }
];


@NgModule({
  declarations: [
    OtrasGestionesComponent,
    FormConsultasComponent,
    FormConsultasFacturacionComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    LayoutModule,
    FlexLayoutModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule,
    MaterialFileInputModule,
    FormsModule,
    MatOptionModule,
    MatSnackBarModule
  ]
})
export class OtrasGestionesModule { }
